import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import styled from '@emotion/styled';

interface BtnProps {
  borderColor?: string; // 예: "#888"
  borderRadius?: string; // 선택: "12px" 같은거
  padding?: string; // 선택
  bgColor?: string; // 선택: 배경색
}

export const BtnStyled = styled.a<BtnProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: ${({ padding }) => padding || '16px 24px'};
  border-radius: ${({ borderRadius }) => borderRadius || '12px'};

  border: 1px solid ${({ borderColor }) => borderColor || '#000'};

  background: ${({ bgColor }) => bgColor || 'transparent'};

  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    flex: 1;
  }
`;

export const BtnTransparent = styled.button<{ border: string }>`
  display: flex;
  padding: 16px 24px;
  justify-content: center;
  align-items: center;

  border-radius: 12px;

  ${({ border }) => border && `border : ${border};`}

  background: transparent;
  cursor: pointer;
`;

export const ShowMoreButton = styled.a`
  cursor: pointer;
  width: 98px;
  height: 20px;
  display: flex;
  object-fit: contain;

  & img {
    width: 100%;
    height: 100%;
  }
`;

export const CloseBtn = styled.img<{ size: string }>`
  cursor: pointer;
  margin-left: auto;
  ${({ size }) => size && `width : ${size}px; height : ${size}px;`}
`;
